<script>
import Academic from '../index.vue';
import { buildAcademicResourceTabs } from '../constants';
export default {
  extends: Academic,
  async created() {
    await this.initPermission();
    await this.initPageData();
    this.init = true;
  },
  methods: {
    async initPermission() {
      this.$login.teacherPermitted();
    },
    async initPageData() {
      let res = await this.$api.get.getTeacherAcademicResource();
      if (res.status === this.$code.SUCCESS) {
        this.data = res.data || {};
        this.tabs = buildAcademicResourceTabs(this.data);
        this.tab = this.tabs[0]?.value || '';
      }
    },
    async postReaded() {},
    async getNewUrl(url) {
      return await this.$api.post.postTeacherWatermarkCourse({
        url
      });
    }
  }
};
</script>
